









































































































































































import { DictServiceProxy,MenuServiceProxy, Menu } from '@/service-proxies/app-v2/system.service-proxies'
import ChooseIcon from './ChooseIcon.vue'
import { mapGetters } from 'vuex'

const menuServiceProxy = new MenuServiceProxy()
const dictService = new DictServiceProxy()

function helper(arr) {
  const res = []
  if (!arr || !arr.length) {
    return res
  }
  for (const item of arr) {
    const target = {
      value: item.id,
      label: item.name,
      children: helper(item.children)
    }
    if (!target.children.length) {
      delete target.children
    }
    res.push(target)
  }
  // 再添加一层app
  return res
}
export default {
  components: {
    ChooseIcon
  },
  data() {
    return {
      modalLoading: false,
      visibleChoose: false,
      topMenuList: [],
      treeData: [],
      checkedKindList: '', // 所选菜单属性
      menuKind: [], // 菜单属性列表
      category: 1,
      loading: false, // 新增or 编辑 loading
      audience: [],
      data: []
    }
  },
  computed: {
    ...mapGetters(['currentApp']),
    isEdit() {
      return this.item.id== undefined ? false : true;
    },
    form() {
      return this.$form.createForm(this)
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    chooseMenuKind: {
      type: String,
      default: ''
    },
    menuTypeList: {
      type: Array,
      default: ()=>[]
    },
    audienceList: {
      type: Array,
      default: ()=>[]
    }
  },
  watch: {
    item(val) {
      if (val) {
        this.getLazyTopMenus()
        this.getKindList()
      }
    }
  },
  created() {
    this.category = this.item.category || 1
    this.load()
    this.getLazyTopMenus()
    this.getKindList()
    this.getAudience();

  },
  methods: {
    defaultCategory(item){
      let value = 1 
      if(item.category){
        console.log(item.kind)
        if(item.kind == '2'){
          value = 3
        } else {
          value = item.category
        }
      }
      return value
    },
    load() {
      this.data = []
      menuServiceProxy.lazyList('', '3', '','').then(res=>{
        let temp = res.data
        if (!temp) return
        // this.data = res.data
        this.data = [{
          id: '0',
          children: temp,
          name: 'APP'
        }]
        this.treeData = helper(this.data)
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getAudience() {
      this.audience = []
      const v = this.item.audience
      this.audienceList.forEach((k: any) => {
        const i = Number(k.dictKey)
        if((v & i) === i){
          this.audience.push(k.dictKey)
        }
      })
    },
    getKindList(){
      this.menuKind = []
      dictService.dictionary('menu_kind').then(res =>{
        if(res.data) {
          this.menuKind = res.data
        }
      })
    },
    getLazyTopMenus() {
      // menuServiceProxy.lazyListGET('', '', 0).then(res => {
      // if (this.isEdit) {
      //   this.form.setFieldsValue({
      //     name: this.item.name ? this.item.name : '',
      //     source: this.item.parentId === '0' && this.item.source ? this.item.source : '',
      //     alias: this.item.code ? this.item.code : '',
      //     sort: this.item.sort ? this.item.sort : '',
      //     code: this.item.code ? this.item.code : '',
      //     path: this.item.path ? this.item.path : '',
      //     parentId: this.getTopMenu(),
      //     edition: this.item.edition ? this.item.edition : '',
      //     category: this.item.category ? this.item.category : 1
      //   })
      // } else {
      //   this.getTopMenu()
      // }
      // })
    },
    addVlaue(item: any){
      let audie = 0
      item.forEach((element: any) => {
        audie = Number(element) + audie
      });
      return audie
    },
    onApply() {
      this.form.validateFields((err, values) => {
        if(this.loading){return};
        // this.loading = true;
        if (!err) {
          if (!values.parentId) {
            values.parentId = 0
          }
          if (this.isEdit) {
            values.id = this.item.id
          }
          if(values.audience){
            values.audience = this.addVlaue(values.audience)
          }

          if(values.category === 3) {
            values.kind = '2'
            values.category = 1
          } else {
            values.kind = '1'
          }
          menuServiceProxy.submit(new Menu(values)).then(() => {
            this.$message.info('保存成功')
            this.sendCloseMsg(true)
            this.loading=false;
          })
        }
      })
    },
    sendCloseMsg(flag) {
      if (this.isEdit) {
        this.$emit('editMenuBack', flag)
      } else {
        this.$emit('addMenuBack', flag)
      }
    },
    choose() {
      this.visibleChoose = true
    },
    getChosenIcon(icon) {
      this.visibleChoose = false
      if (icon) {
        this.form.setFieldsValue({
          source: icon
        })
      }
    },
    getTopMenu() {
      if (!this.isEdit) {
        return ''
      }
      let menuId = ''
      this.treeData.forEach((menu) => {
        menuId = this.handle(menu)
      })
      return menuId
    },
    handle(menu) {
      let menuId = ''
      if (menu.value === this.item.parentId) {
        return menu.value
      }
      if (menu.children && menu.children.length > 0) {
        for (const res of menu.children) {
          menuId = this.handle(res)
          if (menuId !== '') {
            break
          }
        }
      }
      return menuId
    },
    chooseCategory($event) {
      this.category = $event.target.value
    }
  }
}
